import { useDashboardPermissions } from './useDashboardPermissions';
export const DashboardPermissionGuard = ({ permission, children }) => {
    const { hasPermission } = useDashboardPermissions();
    if (!hasPermission(permission)) {
        return null;
    }
    return children;
};
